import { Link } from "react-router-dom";
import { UserRound } from "lucide-react";
import { imgUrl } from "@/lib/api";

export default function MuseCard({ muse, index = 0 }) {
  const img = imgUrl(muse.face_reference_url);
  return (
    <Link
      to={`/muses/${muse.id}`}
      className="group panel overflow-hidden block fade-up hover:border-[#9C4DDC]/60 transition-colors"
      style={{ animationDelay: `${index * 80}ms` }}
      data-testid={`muse-card-${muse.id}`}
    >
      <div className="relative aspect-[4/5] bg-[#FAF7FE] overflow-hidden">
        {img ? (
          <img src={img} alt={muse.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#CDBFE0]"><UserRound size={64} strokeWidth={1} /></div>
        )}
        {muse.is_example && (
          <span className="chip absolute top-3 left-3" data-testid="example-muse-badge">
            Example muse
          </span>
        )}
        {!muse.is_example && muse.wizard_step < 5 && (
          <span className="chip absolute top-3 left-3 bg-white text-[#6B6478]">Draft · step {muse.wizard_step}/5</span>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-xl leading-tight">{muse.name}</h3>
        <p className="text-xs muted mt-1 line-clamp-2">{muse.niche || "Niche not set yet"}</p>
      </div>
    </Link>
  );
}
